<template>
  <BaseDialog ref="popup">
    <div class="content-ct">
      <div class="editor-line form-row">
        <label>{{ keyLabel }}</label>
        <input type="text" v-model="keyModel" />
      </div>
      <hr />
      <span class="label-class">{{ valueLabel }}</span>
      <div class="editor-line intro">
        <vue-editor v-model="valueModel"></vue-editor>
      </div>
    </div>
    <div class="btns">
      <button class="action-btn cancel" @click="_cancel">
        {{ cancelButton }}
      </button>
      <button class="action-btn confirm" @click="_confirm">
        {{ okButton }}
      </button>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '../BaseDialog.vue'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'TextEditorDialog',

  components: { BaseDialog, VueEditor },

  data: () => ({
    // Parameters that change depending on the type of dialogue
    keyModel: '',
    keyLabel: '',
    valueModel: '',
    valueLabel: '',
    okButton: 'Submit', // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: 'Cancel', // text for cancel button
    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.keyModel = opts.key
      this.keyLabel = opts.keyLabel
      this.valueModel = opts.value
      this.valueLabel = opts.valueLabel

      if (opts.okButton) {
        this.okButton = opts.okButton
      }
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      const res = {
        key: this.keyModel,
        value: this.valueModel,
      }
      this.$refs.popup.close()
      this.resolvePromise(res)
    },

    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped>
.btns {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.label-class {
  display: block;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.action-btn {
  padding: 0.5em 1em;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}
.confirm {
  background-color: #282f54;
  color: #fff !important;
}

.cancel {
  background-color: #fd6464;
  color: #fff !important;
}
.content-ct {
  width: 900px;
  height: 500px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
  padding-top: 35px;
}
</style>
